import { render, staticRenderFns } from "./MrmNode.vue?vue&type=template&id=06c9b034&scoped=true"
import script from "./MrmNode.vue?vue&type=script&lang=js"
export * from "./MrmNode.vue?vue&type=script&lang=js"
import style0 from "./MrmNode.vue?vue&type=style&index=0&id=06c9b034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c9b034",
  null
  
)

export default component.exports